import { render, staticRenderFns } from "./happy.vue?vue&type=template&id=38eb2500&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38eb2500')) {
      api.createRecord('38eb2500', component.options)
    } else {
      api.reload('38eb2500', component.options)
    }
    module.hot.accept("./happy.vue?vue&type=template&id=38eb2500&", function () {
      api.rerender('38eb2500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/smileys/happy.vue"
export default component.exports